import React, { useEffect, useRef, useState } from "react";
import { Card, CardNew } from '../../pages/Theme';
import { staticFiles } from '../Helpers/Static'
import MarkDownContent from '../../pages/Journal/MarkDownContent';
import QuickPoll from "../../pages/Journal/QuickPoll";
const CROSS_GRAY_ICON = staticFiles.cross;

const ModalReflectionReview = ({ showModalFeature, setshowModalFeature, htmlContent, quickPollContent, updatedData }) => {
    const [rating, setRating] = useState(0);
    const handleRating = (newRating) => {
        setRating(newRating);
    }
    const showHideModal = showModalFeature
        ? 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex'
        : 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden'
    return (
        <div className={showHideModal} >
            <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4 w-10/12 popUpWidth">
                <button
                    onClick={setshowModalFeature}
                    className="text-gray-600 hover:text-black text-3xl absolute right-6 top-3 w-4 cursor-pointer hover:opacity-60"
                >&times;
                </button>
                <CardNew className="w-90 md:w-full overflow-auto bg-white model-section py-3 border20px filter">
                    <div className="px-4 md:px-8">
                        <h1 className='font-bold mb-3 blackColor'>Feedback</h1>
                        <MarkDownContent htmlContent={htmlContent} className={false} tableHeader={true}/>
                    </div>
                    {(quickPollContent && quickPollContent.length != 0) &&
                        <div className="flex reviewTab p-1 px-4 md:px-8 justify-between">
                            <label className="text-sm font-semibold">Quick Poll</label>
                        </div>
                    }
                    <div className="px-4 md:px-8">
                        {(quickPollContent && quickPollContent.length != 0) && <QuickPoll data={quickPollContent} updatedData={updatedData} />}
                    </div>
                </CardNew>
            </section>
        </div>
    )
}
export default ModalReflectionReview